import { SearchScenarioId } from 'owa-search-next-common';
import { SubstrateSearchSuggestionSegment } from 'owa-search-service';
import { action } from 'satcheljs';

const onGuidedFormulationSuggestionSelectedInternal = action(
    'onGuidedFormulationSuggestionSelectedInternal',
    (segments: SubstrateSearchSuggestionSegment[], scenarioId: SearchScenarioId) => ({
        segments,
        scenarioId,
    })
);

export default onGuidedFormulationSuggestionSelectedInternal;
